import i18next from 'i18next';
import I18NextHttpBackend from 'i18next-http-backend';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
i18next
    .use(I18NextHttpBackend)
    .use(I18nextBrowserLanguageDetector)
    .use(initReactI18next)
    .init({
    debug: true,
    detection: {
        order: ['localStorage', 'cookie', 'querystring'],
        caches: ['localStorage', 'cookie'],
        lookupLocalStorage: 'lang',
        lookupQuerystring: 'lang',
        lookupCookie: 'lang',
    },
    fallbackLng: ['ru', 'kg'],
    interpolation: {
        escapeValue: false,
    },
    backend: {
        loadPath: window.location.host.includes('localhost')
            ? '/locales/{{lng}}/translation.json'
            : '/avn33/locales/{{lng}}/translation.json',
    },
});
export default i18next;
